import React, { lazy } from 'react';
import { MapPin, Sun, Droplets, Mail, Handshake } from 'lucide-react';
export function EysMadeInUsa() {
  return <>
      {/* Made in USA / quality band */}
      <section className="w-full bg-slate-50 border-y border-slate-200" data-id="element-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-14" data-id="element-51">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center" data-id="element-52">
            <div className="lg:col-span-7" data-id="element-53">
              <div className="inline-flex items-center gap-2 text-marine-blue text-xs font-semibold uppercase tracking-wider mb-3" data-id="element-54">
                <MapPin className="w-4 h-4" data-id="element-55" />
                Made in Springfield, Missouri
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-marine-navy mb-4" data-id="element-56">
                Highly Durable and Made in the USA
              </h2>
              <p className="text-slate-700 leading-relaxed mb-5" data-id="element-57">
                Made from durable high-density UV-stabilized polyethylene,
                Extend Your Step and Extend Your Step 3 will last for years to
                come and are built for all types of weather and marine
                environments. Produced in the USA in Springfield, Missouri — you
                can trust in the quality of our products.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-58">
                <div className="flex items-start gap-3 bg-white p-4 rounded-lg border border-slate-200" data-id="element-59">
                  <Sun className="w-5 h-5 text-marine-cyan flex-shrink-0 mt-0.5" data-id="element-60" />
                  <div data-id="element-61">
                    <div className="text-sm font-semibold text-marine-navy" data-id="element-62">
                      UV-Stabilized
                    </div>
                    <div className="text-xs text-slate-600" data-id="element-63">
                      Built for the sun
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-3 bg-white p-4 rounded-lg border border-slate-200" data-id="element-64">
                  <Droplets className="w-5 h-5 text-marine-cyan flex-shrink-0 mt-0.5" data-id="element-65" />
                  <div data-id="element-66">
                    <div className="text-sm font-semibold text-marine-navy" data-id="element-67">
                      Marine-Grade
                    </div>
                    <div className="text-xs text-slate-600" data-id="element-68">
                      All weather, all water
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-3 bg-white p-4 rounded-lg border border-slate-200" data-id="element-69">
                  <MapPin className="w-5 h-5 text-marine-cyan flex-shrink-0 mt-0.5" data-id="element-70" />
                  <div data-id="element-71">
                    <div className="text-sm font-semibold text-marine-navy" data-id="element-72">
                      USA Made
                    </div>
                    <div className="text-xs text-slate-600" data-id="element-73">
                      Springfield, MO
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:col-span-5 flex justify-center" data-id="element-74">
              <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm max-w-sm w-full text-center" data-id="element-75">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.clrmarine.com/preview/uploaded/images/Made-in-America.jpg?opt=w3" alt="Made in America" title="Made in America" loading="lazy" className="w-full max-w-xs mx-auto object-contain" data-id="element-76" />
                <p className="text-sm text-slate-700 mt-4" data-id="element-77">
                  Made exclusively for and sold by <strong data-id="element-78">CLR Marine</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA band */}
      <section className="w-full bg-marine-blue text-white" data-id="element-79">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-14" data-id="element-80">
          <div className="text-center mb-8" data-id="element-81">
            <h2 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-82">
              Ready to make boarding easier?
            </h2>
            <p className="text-slate-100/90 max-w-2xl mx-auto" data-id="element-83">
              Order today, get help with assembly, or reach out with any
              questions. Dealer inquiries are welcome.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto mb-6" data-id="element-84">
            <a href="https://www.clrmarine.com/m4/0CLR_1--extend‑your‑marine‑boarding‑ladder‑clr1.html" className="inline-flex items-center justify-center gap-2 bg-white text-marine-blue hover:bg-marine-cyan hover:text-marine-navy font-semibold px-5 py-3.5 rounded-lg transition-colors" data-id="element-85">
              Purchase Extend Your Step
            </a>
            <a href="https://www.clrmarine.com/m4/0CLR_3--40‑inch‑marine‑boarding‑ladder‑extension‑0clr-3.html" className="inline-flex items-center justify-center gap-2 bg-marine-navy text-white hover:bg-slate-900 font-semibold px-5 py-3.5 rounded-lg transition-colors border border-white/20" data-id="element-86">
              Purchase Extend Your Step Three
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm pt-5 border-t border-white/20" data-id="element-87">
            <a href="https://www.clrmarine.com/530.html" className="inline-flex items-center gap-2 text-white/90 hover:text-white underline-offset-4 hover:underline" data-id="element-88">
              Assembly Directions
            </a>
            <a href="https://www.clrmarine.com/594.html" className="inline-flex items-center gap-2 text-white/90 hover:text-white underline-offset-4 hover:underline" data-id="element-89">
              How to Use It
            </a>
            <a href="99.html" className="inline-flex items-center gap-2 text-white/90 hover:text-white underline-offset-4 hover:underline" data-id="element-90">
              <Mail className="w-4 h-4" data-id="element-91" />
              Contact Us with Questions
            </a>
            <a href="99.html" className="inline-flex items-center gap-2 text-white/90 hover:text-white underline-offset-4 hover:underline" data-id="element-92">
              <Handshake className="w-4 h-4" data-id="element-93" />
              Dealer Inquiries Welcome
            </a>
          </div>
        </div>
      </section>
    </>;
}